import { createHashHistory, createMemoryHistory } from 'history';
import { maybeRedirectAzureCallback } from './utils/azureAuth';

maybeRedirectAzureCallback();

export const history =
  process.env.NODE_ENV !== 'test' ? createHashHistory() : createMemoryHistory();
